<div class="page-footer"
     save-timer>

  <div class="f1-footer pop-display-flex">

    <div class="pop-display-flex">
      <button (click)="showDoc()"
              [matTooltip]="'FOOTER.HELP' | translate"
              position="above"
              class="footer-help-btn font-normal bold">
        F1
      </button>
      <div (click)="showVersion()"
           class="footer-poweredby pop-display-flex">
        <span class="font-normal"
              translate="FOOTER.POWERED_BY"></span>
        <img src="./assets/images/logo-jovaco-dk-sm.png" />
      </div>
    </div>

    <div class="footer-status pop-display-flex">
      <i class="far fa-save"
         *ngIf="savingStatus === 'Saved'"
         (click)="saveChanges()"></i>
      <span *ngIf="savingStatus === 'Saving'"
            class="font-normal warning">
        <i class="far fa-clock"></i>
        <span class="font-normal"
              translate="FOOTER.SAVING"></span>
      </span>
      <span *ngIf="savingStatus === 'Error'"
            class="font-normal error">
        <i class="far fa-times-circle"></i>
        <span class="font-normal"
              translate="FOOTER.ERROR"></span>
      </span>
    </div>
  </div>
</div>
